export default "__VITE_PUBLIC_ASSET__ccb76540__"